'use strict';

export default {
  api: {
    // Lore
    getAllLore: '/lore',
    getLoreById: '/lore/{id}',
    addLore: '/lore',
    updateLore: '/lore/{id}',
    // ContentBlock
    getAllContentBlock: '/content-blocks',
    getContentBlockById: '/content-block/{id}',
    addContentBlock: '/content-block',
    updateContentBlock: '/content-block/{id}',
    // Campaign Setting
    getAllCampaignSettings: '/campaign-settings',
    getCampaignSettingById: '/campaign-setting/{id}',
    addCampaignSetting: '/campaign-setting',
    updateCampaignSetting: '/campaign-setting/{id}',
    // User
    getAllUsers: '/users',
    getUserById: '/user/{id}',
    addUser: '/user',
    updateUser: '/user/{id}'
  },
  mongodb: {
    connectionString: 'mongodb://localhost:27017/lore-master',
    collections: {
      lore: {
        name: 'lore',
        indexes: [{
          field: 'id',
          options: {
            unique: true
          }
        }, {
          field: 'name',
          options: {
            unique: true
          }
        }, {
          field: 'author'
        }, {
          field: ''
        }]
      },
      user: {
        name: 'users',
        indexes: [{
          field: 'id',
          options: {
            unique: true
          }
        }, {
          field: 'name',
          options: {
            unique: true
          }
        }]
      },
      campaignSettings: {
        name: 'campaign-settings',
        indexes: [{
          field: 'id',
          options: {
            unique: true
          }
        }, {
          field: 'name',
          options: {
            unqiue: true
          }
        }]
      },
      contentBlock: {
        name: 'content-blocks',
        indexes: [
          {
            field: 'id',
            options: {
              unique: true
            }
          },
          {
            field: 'permissions'
          }
        ]
      }
    },
    options: {

    }
  }
}
